import {PRODUCT_FRUITS_WORKSPACE_CODE} from 'client/common/config';

export const destroyProductFruits = () => {
  if (PRODUCT_FRUITS_WORKSPACE_CODE) {
    window?.productFruits?.services?.destroy();
  }
};
